/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MxConnectWidgetUrlRequest
 */
export interface MxConnectWidgetUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof MxConnectWidgetUrlRequest
     */
    institutionCode: string;
    /**
     * Whether to use the mobile webview.
     * @type {boolean}
     * @memberof MxConnectWidgetUrlRequest
     */
    mobileWebview?: boolean;
}

/**
 * Check if a given object implements the MxConnectWidgetUrlRequest interface.
 */
export function instanceOfMxConnectWidgetUrlRequest(value: object): value is MxConnectWidgetUrlRequest {
    if (!('institutionCode' in value) || value['institutionCode'] === undefined) return false;
    return true;
}

export function MxConnectWidgetUrlRequestFromJSON(json: any): MxConnectWidgetUrlRequest {
    return MxConnectWidgetUrlRequestFromJSONTyped(json, false);
}

export function MxConnectWidgetUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MxConnectWidgetUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'institutionCode': json['institution_code'],
        'mobileWebview': json['mobile_webview'] == null ? undefined : json['mobile_webview'],
    };
}

export function MxConnectWidgetUrlRequestToJSON(json: any): MxConnectWidgetUrlRequest {
    return MxConnectWidgetUrlRequestToJSONTyped(json, false);
}

export function MxConnectWidgetUrlRequestToJSONTyped(value?: MxConnectWidgetUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'institution_code': value['institutionCode'],
        'mobile_webview': value['mobileWebview'],
    };
}

